import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {
  getTaskEfforPerPage,
  getTop10TaskEffort,
} from "store/bailiff/task/effort/task_effort.action";
//
//component
//redux
//selector
//actions
const TriggerPage = () => {
  // -------------------------- VAR ----------------------------
  const [searchParams] = useSearchParams();
  const openViewScore = searchParams.get("viewOpenScore") || "false";
  const tab = searchParams.get("tab") || "pass";
  const pageNo = searchParams.get("page") || "1";
  const openScore = openViewScore === "true" || false;
  const open = openScore;
  const page = parseInt(pageNo);
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (open && tab) {
      // nếu page= 1.
      if (page === 1) {
        dispatch(getTop10TaskEffort({ tab }));
      } else if (page > 1) {
        dispatch(getTaskEfforPerPage({ page, tab }));
      }
    }
  }, [open, tab, page, dispatch]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerPage;
